import { LoopFilterTags, LoopRouteType } from "@bridgesplit/abf-sdk";
import { JLP_MINT, ONYC_MINT } from "@bridgesplit/utils";

import { isExponentLoop, isLstLoop, isRatexLoop } from "../api";
import { LoopExpanded } from "../types";
import { BsMetaUtil } from "../utils";

export const METEORA_POLL_INTERVAL = 15_000;
export const JUPITER_POLL_INTERVAL = 15_000;

export const getLoopSlippageTooltip = (loopExpanded: LoopExpanded, side: "wind" | "unwind") => {
    const principalSymbol = BsMetaUtil.getSymbol(loopExpanded.principalToken);
    const collateralSymbol = BsMetaUtil.getSymbol(loopExpanded.collateralToken);
    if (side === "wind") {
        return `Max slippage you're willing to accept on the swap from ${principalSymbol} to ${collateralSymbol}`;
    }
    return `Max slippage you're willing to accept on the swap from ${collateralSymbol} to ${principalSymbol}`;
};

export function getLoopSlippage(loop: LoopExpanded | undefined): {
    defaultSlippageUi: number;
    slippagePresetsUi: number[];
} {
    if (loop) {
        if (isLstLoop(loop)) {
            return { defaultSlippageUi: 0.02, slippagePresetsUi: [0.02, 0.1, 0.5] };
        }
        if (isRatexLoop(loop)) {
            return { defaultSlippageUi: 0.05, slippagePresetsUi: [0.05, 0.1, 0.5] };
        }
        if (isExponentLoop(loop)) {
            return { defaultSlippageUi: 0.02, slippagePresetsUi: [0.02, 0.1, 0.5] };
        }
        if (loop.collateralToken.mint === JLP_MINT) {
            return { defaultSlippageUi: 0.25, slippagePresetsUi: [0.25, 0.5, 1] };
        }

        if (loop.loopVault.routeType === LoopRouteType.Orca) {
            if (loop.loopVault.tags?.includes(LoopFilterTags.Directional)) {
                return { defaultSlippageUi: 0.25, slippagePresetsUi: [0.25, 0.5, 1] };
            }

            return { defaultSlippageUi: 0.01, slippagePresetsUi: [0.01, 0.05, 0.1] };
        }

        if (loop.collateralToken.mint === ONYC_MINT) {
            return { defaultSlippageUi: 0.01, slippagePresetsUi: [0.01, 0.025, 0.1] };
        }

        if (loop.loopVault.routeType === LoopRouteType.Meteora) {
            return { defaultSlippageUi: 0.1, slippagePresetsUi: [0.1, 0.5, 1] };
        }
    }

    return { defaultSlippageUi: 0.5, slippagePresetsUi: [0.5, 1, 2] };
}

export const FEATURED_LOOPS = [
    "solv-fragbtc-30Sep25-zbtc",
    "sphSo1j2eTLa6AB5Wjrmap8VbQoZKccCpqJ7gV5pqGM",
    "flp1USDCtN5SP72BsefbsqpnbAY5oe21LE8bCSkqsEK",
    "expfragsole3yexj2gbQtx929zBJtWJRM8TeTzYbQBgx"
];

export const TRENDING_LOOPS_COUNT = 3;
